import { ArrowsPointingInIcon, ArrowsPointingOutIcon } from '@heroicons/react/24/outline';

import { Icon } from '@/components/core/Icon';
import { Toggle } from '@/components/core/Toggle';
import { useTranslation } from '@/hooks/useTranslation';

enum EditorWidth {
    Screen = 'screen',
    Mobile = 'mobile'
}

interface EditorToolbarProps {
    editorWidth: EditorWidth;
    setEditorWidth: (width: EditorWidth) => void;
}

const EditorToolbar = ({ editorWidth, setEditorWidth }: EditorToolbarProps) => {

    const { t } = useTranslation();

    return (
        <div className="tw-w-full tw-flex tw-flex-row-reverse tw-p-2 tw-shadow tw-z-10">
            <Toggle
                className="data-[state=on]:tw-text-gray-800 data-[state=on]:tw-bg-gray-200 data-[state=off]:tw-text-gray-300 data-[state=off]:tw-bg-transparent"
                title={t('ENHANCED_CONTENT.MINIMIZE_MAXIMIZE_VIEWPORT')}
                aria-label={t('ENHANCED_CONTENT.MINIMIZE_MAXIMIZE_VIEWPORT')}
                pressed={editorWidth === EditorWidth.Mobile}
                onPressedChange={(pressed) => pressed ? setEditorWidth(EditorWidth.Mobile) : setEditorWidth(EditorWidth.Screen)}
            >
                { editorWidth === EditorWidth.Screen ? <Icon icon={ArrowsPointingInIcon} size='sm'/> : <Icon icon={ArrowsPointingOutIcon} size='sm'/>}
            </Toggle>
        </div>
    );
};

export { EditorToolbar, EditorWidth };
